module.exports = __webpack_public_path__ + "img/nodejs.f9448c3a.svg";